import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { IObservationDefinition } from "@comunicare/comunicare-interfaces";
import { SessionService } from "../providers/session.service";

@Pipe({ name: "translateObservationNameFromObsDef" })
export class TranslateObservationNameFromObsDefPipe implements PipeTransform {
  constructor(private sessionService: SessionService) {}

  /**
   * Translates the observation name
   * @param observationDef The current observation
   * @returns A translated string
   */
  transform(observationDef: IObservationDefinition): string {
    return Tools.getTranslation(observationDef.nameTranslation, this.sessionService.userLang, observationDef.loinc);
  }
}
